import { API_ENDPOINTS, API_PREFIX } from '@/config/const';
import { APP_ENV } from '@/config/env';
import { GetMeResponse } from '@/types';
import { ResponseError } from '@/utils/Errors/ResponseError';

export async function getMe(accessToken: string): Promise<GetMeResponse> {
  const response = await fetch(`${APP_ENV.apiUrl}/${API_PREFIX}/${API_ENDPOINTS.me}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  });

  if (!response.ok) {
    throw new ResponseError('Failed on get me request', response);
  }

  return await response.json();
}
